export const roleAuth = (slug, identtifier) => {
    const userAccess = sessionStorage.getItem("Features");
    const features = userAccess ? JSON.parse(userAccess) : [];
    let isAuthorized = false;
    features.forEach((category) => {
        category.features.forEach((feature) => {
            if (feature.slug === slug) {
                feature.functions.forEach((func) => {
                    if (func === identtifier) {
                        isAuthorized = true;
                    }
                })
            }
        })
    });
    return isAuthorized;
}

export const authFunction = (slug, identtifier, func) => {
    if (roleAuth(slug, identtifier)) {
        return func;
    }else{
        return null;
    }

}